import { rgba } from 'polished';

const black = '#000000';

export default {
  cardDefault: `0 0 10px 0 ${rgba(black, 0.08)}`,
  contextual: `2px 2px 6px 0 ${rgba(black, 0.2)}`,
  filters: `0 2px 3px 0 ${rgba(black, 0.1)}`,
};
